import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', async () => {
    const hadController = Boolean(navigator.serviceWorker.controller)
    const registration = await navigator.serviceWorker.register(`/sw.js?v=${__APP_VERSION__}`)
    registration.addEventListener('updatefound', () => {
      const worker = registration.installing
      worker?.addEventListener('statechange', () => {
        if (worker.state === 'installed' && hadController) {
          window.dispatchEvent(new Event('pass-creator:update'))
        }
      })
    })
  })
}
